import {
  FETCH_REGISTER_FAILURE,
  FETCH_REGISTER_REQUESTED,
  FETCH_REGISTER_SUCCESS,
} from 'actiontypes/registration';

import RegisterService from 'services/RegisterService';

const service = new RegisterService();

/** ----------------------------------------------------------------------------
 * FETCH
 -----------------------------------------------------------------------------*/
export default function fetch() {
  return async (dispatch) => {
    dispatch(fetchRequested());
    try {
      const { data } = await service.fetch();
      dispatch(fetchSuccess(data));
      return data;
    } catch (error) {
      dispatch(fetchFailure(error));
    }
  };
}

export const fetchRequested = () => ({ type: FETCH_REGISTER_REQUESTED });

export const fetchSuccess = data => ({ type: FETCH_REGISTER_SUCCESS, payload: data });

export const fetchFailure = error => ({
  type: FETCH_REGISTER_FAILURE,
  error: true,
  status: error.response && error.response.status,
});